import React from 'react';

import propTypes from 'prop-types';
import TopNavBar from '../TopNavBar';
import moment from 'moment';

import IconButton from '@material-ui/core/IconButton';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import './adminSpecificMeetingView.css';
import { defaultParticipantName } from '../../configFiles/config';
import showSuccessToast from '../../utils/toasts/showSuccessToast';
import showErrorToast from '../../utils/toasts/showErrorToast';
// import { CREATE_NEW_MEETING_FULFILLED } from '../../redux/meeting/actionTypes';

const getRecordingUrl = (gcsUrl) => {
  if (!gcsUrl) {
    return gcsUrl;
  }

  if (gcsUrl.startsWith('gs://')) {
    const path = gcsUrl.replace('gs://', '');
    return `https://storage.cloud.google.com/${path}`;
  }

  return gcsUrl;
};

const formatAttendanceDuration = (totalSeconds = 0) => {
  const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${remainingSeconds}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${remainingSeconds}s`;
  }
  return `${remainingSeconds}s`;
};

class AdminSpecificMeetingView extends React.Component {
  constructor (props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount () {
    const {
      adminToken,
      getMeetingDetailsForSelectedMeeting,
      match,
    } = this.props;

    if (!adminToken) {
      window.location.assign('/admin/login');
    }

    const meetingId = match && match.params && match.params.meetingId;

    if (!meetingId) {
      window.location.assign('/admin/meetings/view');
    }

    getMeetingDetailsForSelectedMeeting(meetingId);
  }

  downloadMeetingContentHistory = () => {
    const {
      meetingDetailsOfSelectedMeeting,
    } = this.props;

    const content = meetingDetailsOfSelectedMeeting.content;

    const {
      title,
    } = meetingDetailsOfSelectedMeeting;
    // doc.save(`${title}.pdf`);

    let finalTextToDownload = '';

    content && content.forEach((contentRecord) => {
      const clientDetails = contentRecord.clientDetails;
      const name = clientDetails.name || defaultParticipantName;

      finalTextToDownload += `${name}\n\n`;

      const usersContentHistory = contentRecord.contentHistory;
      usersContentHistory && usersContentHistory.forEach((usersContentHistoryRecord) => {
        const createdAt = moment(usersContentHistoryRecord.createdAt).format('DD-MM-YYYY HH:mm:ss');
        const submission = usersContentHistoryRecord.content;
        const {
          code,
          language,
        } = submission;

        finalTextToDownload += `${language}\t\t\t\t${createdAt}\n\n`;
        finalTextToDownload += code;
        finalTextToDownload += '\n\n\n\n';
      });
      finalTextToDownload += '\n\n--------------------------------------------------------------\n\n';
    });

    // const header = '<html xmlns:o=\'urn:schemas-microsoft-com:office:office\' ' +
    // 'xmlns:w=\'urn:schemas-microsoft-com:office:word\' ' +
    // 'xmlns=\'http://www.w3.org/TR/REC-html40\'>' +
    // '<head><meta charset=\'utf-8\'><title>Editor Content</title></head><body>';
    // const footer = '</body></html>';


    var sourceHTML = finalTextToDownload;

    var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement('a');
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = `${title}.doc`;
    fileDownload.click();
    document.body.removeChild(fileDownload);
  }

  copyTextToClipboard = (textToCopy) => {
    if (!textToCopy) {
      return;
    }

    const fallbackCopy = () => {
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const isCopied = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (!isCopied) {
        throw new Error('COPY_FAILED');
      }
    };

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          showSuccessToast('Link copied');
        })
        .catch(() => {
          try {
            fallbackCopy();
            showSuccessToast('Link copied');
          } catch (error) {
            showErrorToast('Unable to copy link');
          }
        });
      return;
    }

    try {
      fallbackCopy();
      showSuccessToast('Link copied');
    } catch (error) {
      showErrorToast('Unable to copy link');
    }
  }

  renderMeetingLink = (meetingLink) => {
    if (!meetingLink) {
      return null;
    }

    return (
      <div className='adminViewMeetingDetailsLinkRow'>
        <a
          href={meetingLink}
          target='_blank'
          rel='noopener noreferrer'
          className='adminViewMeetingDetailsAnchorLink'
        >
          {meetingLink}
        </a>
        <IconButton
          className='adminViewMeetingDetailsCopyButton'
          aria-label='Copy meeting link'
          title='Copy meeting link'
          size='small'
          onClick={() => this.copyTextToClipboard(meetingLink)}
        >
          <FileCopyIcon fontSize='small' />
        </IconButton>
      </div>
    );
  }

  render () {
    const {
      meetingDetailsOfSelectedMeeting,
    } = this.props;

    const recordings = meetingDetailsOfSelectedMeeting.recordings || [];
    const attendanceParticipants =
      (meetingDetailsOfSelectedMeeting.attendance &&
        meetingDetailsOfSelectedMeeting.attendance.participants) ||
      [];

    return (
      <div className='adminViewMeetingDetailsContainer'>
        <div className='adminViewMeetingDetailsTopNavBarContainer'>
          <TopNavBar />
        </div>
        <div className='adminViewMeetingDetailsMeetingDataContainer'>
          <div className='adminViewMeetingDetailsTitle'>
            {meetingDetailsOfSelectedMeeting.title}
          </div>
          <div className='adminViewMeetingDetailsTimeContainer'>
            <div className='adminViewMeetingDetailsStartTime'>
              {moment(meetingDetailsOfSelectedMeeting.startTime).format('DD-MM-YYYY HH:mm')}
            </div>
            &nbsp;-&nbsp;
            <div className='adminViewMeetingDetailsEndTime'>
              {moment(meetingDetailsOfSelectedMeeting.endTime).format('DD-MM-YYYY HH:mm')}
            </div>
          </div>
          <div className='adminViewMeetingDetailsHasMeetingStarted'>
            Meeting started&nbsp;:&nbsp;{meetingDetailsOfSelectedMeeting.hasMeetingStarted ? 'Yes' : 'No'}
          </div>
          <div className='adminViewMeetingDetailsHasMeetingEnded'>
            Meeting Ended&nbsp;:&nbsp;{
            (meetingDetailsOfSelectedMeeting && meetingDetailsOfSelectedMeeting.hasMeetingEnded &&
              meetingDetailsOfSelectedMeeting && !meetingDetailsOfSelectedMeeting.hasMeetingStarted) ?
              'Canceled'
              :
              (
                (meetingDetailsOfSelectedMeeting.endTime < moment.now() &&
                  meetingDetailsOfSelectedMeeting && !meetingDetailsOfSelectedMeeting.hasMeetingStarted) ?
                  'Yes'
                  :
                  (meetingDetailsOfSelectedMeeting.hasMeetingEnded ?
                    'Yes'
                    :
                    (meetingDetailsOfSelectedMeeting.endTime < moment.now() ?
                      'Yes'
                      :
                      'No'
                    )
                  )
              )
          }
          </div>
          {
            meetingDetailsOfSelectedMeeting.password ?
              <div className='adminViewMeetingPassword'>
                <div>
                  Password&nbsp;:&nbsp;
                </div>
                {meetingDetailsOfSelectedMeeting.password}
              </div>
              :
              null
          }
          <div className='adminViewMeetingDetailsPublicLink'>
            <div>
              Public link&nbsp;:&nbsp;
            </div>
            {this.renderMeetingLink(meetingDetailsOfSelectedMeeting.joinLink)}
          </div>
          {
            recordings && recordings.length > 0 ?
              <div className='adminViewMeetingDetailsRecordingsContainer'>
                <div className='contentDetailsTitleContainer'>
                  Recordings:
                </div>
                <div className='adminViewMeetingDetailsRecordingsList'>
                  {
                    recordings.map((recording, index) => {
                      const createdAt = recording.created_at || recording.createdAt;
                      const label = createdAt ?
                        moment(createdAt).format('DD-MM-YYYY HH:mm:ss') :
                        `Recording ${recordings.length - index}`;
                      const key = recording.id || `${index}-${label}`;
                      const recordingUrl = getRecordingUrl(recording.gcs_url);
                      const isRecordingInProgress = recording.status === 'IN_PROGRESS';
                      return (
                        <div
                          key={key}
                          className='adminViewMeetingDetailsRecording'
                        >
                          <div className='adminViewMeetingDetailsRecordingMeta'>
                            <div className='adminViewMeetingDetailsRecordingLabel'>
                              {label}
                            </div>
                            <div className='adminViewMeetingDetailsRecordingStatus'>
                              {recording.status || 'UNKNOWN'}
                            </div>
                          </div>
                          <div
                            className='adminViewMeetingDetailsRecordingLink'
                            disabled={isRecordingInProgress}
                            title={isRecordingInProgress ? 'Recording is in progress' : ''}
                          >
                            {
                              recordingUrl ?
                                <a
                                  href={isRecordingInProgress ? undefined : recordingUrl}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  onClick={isRecordingInProgress ? (e) => e.preventDefault() : undefined}
                                  aria-disabled={isRecordingInProgress}
                                  className={isRecordingInProgress ? 'adminViewMeetingDetailsRecordingLinkDisabled' : 'adminViewMeetingDetailsRecordingLink'}
                                >
                                  Open recording
                                </a>
                                :
                                <span>
                                  Recording URL not available
                                </span>
                            }
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
              :
              null
          }
          {
            attendanceParticipants.length > 0 ?
              <div className='adminViewMeetingDetailsAttendanceContainer'>
                <div className='contentDetailsTitleContainer'>
                  Attendance:
                </div>
                <div className='adminViewMeetingDetailsAttendanceList'>
                  {
                    attendanceParticipants.map((participant) => {
                      const key = participant.email || participant.name;
                      const roleLabel = participant.isModerator ? 'Moderator' : 'Participant';
                      const statusLabel = participant.isCurrentlyInMeeting ? 'In meeting' : 'Left';
                      const percentageLabel = participant.attendancePercentage != null
                        ? `${participant.attendancePercentage}%`
                        : '—';
                      return (
                        <div
                          key={key}
                          className='adminViewMeetingDetailsAttendanceRow'
                        >
                          <div className='adminViewMeetingDetailsAttendancePrimary'>
                            <div className='adminViewMeetingDetailsAttendanceName'>
                              {participant.name || 'Unknown'}
                            </div>
                            <div className='adminViewMeetingDetailsAttendanceEmail'>
                              {participant.email}
                            </div>
                          </div>
                          <div className='adminViewMeetingDetailsAttendanceMeta'>
                            <span>{roleLabel}</span>
                            <span>{statusLabel}</span>
                            <span>{formatAttendanceDuration(participant.totalDurationSeconds)}</span>
                            <span>{percentageLabel}</span>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
              :
              null
          }
          {
            meetingDetailsOfSelectedMeeting.moderatorDetails &&
            Object.keys(meetingDetailsOfSelectedMeeting.moderatorDetails).length > 0 ?
              <div className='adminViewMeetingDetailsModeratorsContainer'>
                <div className='contentDetailsTitleContainer'>
                  Moderators:
                </div>
                <div className='adminViewMeetingDetailsModeratorDetailsContainer'>
                  {
                    (meetingDetailsOfSelectedMeeting.moderatorDetails && Object.keys(meetingDetailsOfSelectedMeeting.moderatorDetails).length > 0) ?
                      <div className='adminViewMeetingDetailsAllModerators'>
                        {
                          Object.keys(meetingDetailsOfSelectedMeeting.moderatorDetails).map((moderatorEmail) => {
                            return (
                              <div
                                key={moderatorEmail}
                                className='adminViewMeetingDetailsModerators'
                              >
                                <div className='adminViewMeetingDetailsModeratorEmail'>
                                  {moderatorEmail}
                                </div>
                                <div className='adminViewMeetingDetailsModeratorLink'>
                                  {this.renderMeetingLink(meetingDetailsOfSelectedMeeting.moderatorDetails[moderatorEmail])}
                                </div>
                              </div>
                            );
                          })
                        }
                      </div>
                      :
                      null
                  }
                </div>
              </div>
              :
              null
          }
          {
            (meetingDetailsOfSelectedMeeting.participantDetails &&
              Object.keys(meetingDetailsOfSelectedMeeting.participantDetails).length > 0
            ) ?
              <div className='adminViewMeetingDetailsParticipantsContainer'>
                <div className='contentDetailsTitleContainer'>
                  Participants:
                </div>
                <div className='adminViewMeetingDetailsParticipantDetailsContainer'>
                  {
                    (meetingDetailsOfSelectedMeeting.participantDetails &&
                      Object.keys(meetingDetailsOfSelectedMeeting.participantDetails).length > 0
                    ) ?
                      <div className='adminViewMeetingDetailsAllParticipants'>
                        {
                          Object.keys(meetingDetailsOfSelectedMeeting.participantDetails).map((participantEmail) => {
                            return (
                              <div
                                key={participantEmail}
                                className='adminViewMeetingDetailsParticipants'
                              >
                                <div className='adminViewMeetingDetailsParticipantEmail'>
                                  {participantEmail}
                                </div>
                                <div className='adminViewMeetingDetailsParticipantLink'>
                                  {this.renderMeetingLink(meetingDetailsOfSelectedMeeting.participantDetails[participantEmail])}
                                </div>
                              </div>
                            );
                          })
                        }
                      </div>
                      :
                      null
                  }
                </div>
              </div>
              :
              null
          }
          {
            meetingDetailsOfSelectedMeeting.content && meetingDetailsOfSelectedMeeting.content.length > 0 ?
              <div className='contentDetailsContainer'>
                <div className='contentDetailsTitleContainer'>
                  Code submissions:
                </div>
                <IconButton
                  onClick={this.downloadMeetingContentHistory}
                >
                  <CloudDownloadIcon />
                </IconButton>
                {
                  meetingDetailsOfSelectedMeeting.content.map((contentDetails) => {
                    const clientDetails = contentDetails.clientDetails;
                    const clientId = clientDetails.id;
                    const name = clientDetails.name || defaultParticipantName;

                    const contentHistory = contentDetails.contentHistory;
                    return (
                      <div
                        key={clientId}
                        className='contentDetailsParticipantContainer'
                      >
                        <div className='contentDetailsParticipantName'>
                          Participant : {name}
                        </div>
                        <div className='contentDetailsParticipantSubmissions'>
                          {
                            contentHistory.map((contentRecord, index) => {
                              const contentRecordContent = contentRecord.content;
                              return (
                                <div
                                  key={index}
                                  className='contentDetailsSubmissionRecordContainer'
                                >
                                  <div className='contentDetailsContent'>
                                    <div className='contentDetailsMetaDataContainer'>
                                      <div className='contentDetailsLanguageIndicator'>
                                        {contentRecordContent.language}
                                      </div>
                                      <div className='contentDetailsSumittedAt'>
                                        Submitted at:&nbsp;{moment(contentRecord.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                      </div>
                                    </div>
                                    <div className='contentDetailsCode'>
                                      {contentRecordContent.code}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
              </div>
              :
              null
          }
        </div>
      </div>
    );
  }
}

AdminSpecificMeetingView.propTypes = {
  adminToken: propTypes.string,
  getMeetingDetailsForSelectedMeeting: propTypes.func,
  match: propTypes.object,
  meetingDetailsOfSelectedMeeting: propTypes.object,
};

AdminSpecificMeetingView.defaultProps = {
  adminToken: '',
  getMeetingDetailsForSelectedMeeting: () => { },
  meetingDetailsOfSelectedMeeting: {},
};

export default AdminSpecificMeetingView;
